import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { IAuthenticationService, IAuthenticationExtensionsService } from 'vscode/vscode/vs/workbench/services/authentication/common/authentication.service';
import { AuthenticationService } from 'vscode/vscode/vs/workbench/services/authentication/browser/authenticationService';
import { AuthenticationAccessService } from './vscode/src/vs/workbench/services/authentication/browser/authenticationAccessService.js';
import { AuthenticationUsageService } from './vscode/src/vs/workbench/services/authentication/browser/authenticationUsageService.js';
import { AuthenticationExtensionsService } from './vscode/src/vs/workbench/services/authentication/browser/authenticationExtensionsService.js';
import { IAuthenticationAccessService } from 'vscode/vscode/vs/workbench/services/authentication/browser/authenticationAccessService.service';
import { IAuthenticationUsageService } from 'vscode/vscode/vs/workbench/services/authentication/browser/authenticationUsageService.service';

function getServiceOverride() {
    return {
        [( IAuthenticationService.toString())]: new SyncDescriptor(AuthenticationService, [], true),
        [( IAuthenticationAccessService.toString())]: new SyncDescriptor(AuthenticationAccessService, [], true),
        [( IAuthenticationExtensionsService.toString())]: new SyncDescriptor(AuthenticationExtensionsService, [], true),
        [( IAuthenticationUsageService.toString())]: new SyncDescriptor(AuthenticationUsageService, [], true)
    };
}

export { getServiceOverride as default };
